import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { take9j4462mea726 as take } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  LocalDate31mqn6zavbpi8 as LocalDate,
  Companion_getInstancefc1kb6w5z78x as Companion_getInstance,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { RViewWithActionov1gis5vq13n as RViewWithAction } from '../RView.mjs';
import { KeyCodes_instancevfnkc2xsbiba as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance } from '../../models/data.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../models/data.commonHtml.mjs';
import {
  LocalDateTime3vqv9moe7clf4 as LocalDateTime,
  Companion_getInstance2vzevs5m6d283 as Companion_getInstance_0,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import {
  LocalTime22kisvxz6f9p4 as LocalTime,
  Companion_getInstance3vhybkmm49bju as Companion_getInstance_1,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.wbw_1 = 10;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_2() {
  return Companion_instance;
}
var LocalDateField$content$1Class;
function LocalDateField$content$1() {
  if (LocalDateField$content$1Class === VOID) {
    class $ extends BaseListenable() {
      static zbw(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.ybw_1 = this$0;
        var $this = this.uam($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this$0.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('input', (it) => {
            $this.mal();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.gb4_1['on' + 'input'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'input';
          this_0.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.mal();
            return Unit_instance;
          };
        }
        return $this;
      }
      abx(value) {
        var tmp0 = this.ybw_1.vb5_1.bb4_1;
        var tmp1_safe_receiver = value == null ? null : value.toString();
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var value_0 = tmp1_safe_receiver == null ? null : take(tmp1_safe_receiver, Companion_instance.wbw_1);
        tmp0.kb7_1.value = value_0;
      }
      oam(_set____db54di) {
        return this.abx((_set____db54di == null ? true : _set____db54di instanceof LocalDate()) ? _set____db54di : THROW_CCE());
      }
      f2() {
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.ybw_1.vb5_1.bb4_1.kb7_1.value;
        var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          if (!(charSequenceLength(tmp0_safe_receiver) === 0)) {
            tmp_1 = tmp0_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp1_safe_receiver = tmp_0;
        var tmp_2;
        if (tmp1_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_2 = Companion_getInstance().l25(tmp1_safe_receiver);
        }
        return tmp_2;
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (value == null ? true : value instanceof LocalDate()) ? value : THROW_CCE());
      }
    }
    protoOf($).eak = valueSet;
    protoOf($).iah = set;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    protoOf($).sah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue(), BaseListenable()], [1]);
    LocalDateField$content$1Class = $;
  }
  return LocalDateField$content$1Class;
}
var LocalDateFieldClass;
function LocalDateField() {
  if (LocalDateFieldClass === VOID) {
    class $ extends RViewWithAction() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'input';
        // Inline function 'com.lightningkite.kiteui.views.type' call
        this.vb5_1.bb4_1.kb7_1.type = 'date';
        this.vb5_1.jb4_1.v('editable');
        var tmp = this;
        tmp.nby_1 = LocalDateField$content$1().zbw(this);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax()) {
              var tmp0_safe_receiver = this.mbg_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.zbe(this);
              }
            }
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_0.gb4_1['on' + 'keyup'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keyup';
          this_0.gb4_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax()) {
              var tmp0_safe_receiver_0 = this.mbg_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.zbe(this);
              }
            }
            return Unit_instance;
          };
        }
        this.oby_1 = Align_Start_getInstance();
        this.pby_1 = get_rem(1);
        this.qby_1 = null;
      }
    }
    initMetadataForClass($, 'LocalDateField');
    LocalDateFieldClass = $;
  }
  return LocalDateFieldClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        this.rby_1 = 16;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
var LocalDateTimeField$content$1Class;
function LocalDateTimeField$content$1() {
  if (LocalDateTimeField$content$1Class === VOID) {
    class $ extends BaseListenable() {
      static uby(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.tby_1 = this$0;
        var $this = this.uam($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this$0.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('input', (it) => {
            $this.mal();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.gb4_1['on' + 'input'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'input';
          this_0.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.mal();
            return Unit_instance;
          };
        }
        return $this;
      }
      vby(value) {
        var tmp0 = this.tby_1.vb5_1.bb4_1;
        var tmp1_safe_receiver = value == null ? null : value.toString();
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var value_0 = tmp1_safe_receiver == null ? null : take(tmp1_safe_receiver, Companion_instance_0.rby_1);
        tmp0.kb7_1.value = value_0;
      }
      oam(_set____db54di) {
        return this.vby((_set____db54di == null ? true : _set____db54di instanceof LocalDateTime()) ? _set____db54di : THROW_CCE());
      }
      f2() {
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.tby_1.vb5_1.bb4_1.kb7_1.value;
        var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          if (!(charSequenceLength(tmp0_safe_receiver) === 0)) {
            tmp_1 = tmp0_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp1_safe_receiver = tmp_0;
        var tmp_2;
        if (tmp1_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_2 = Companion_getInstance_0().q25(tmp1_safe_receiver);
        }
        return tmp_2;
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (value == null ? true : value instanceof LocalDateTime()) ? value : THROW_CCE());
      }
    }
    protoOf($).eak = valueSet;
    protoOf($).iah = set;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    protoOf($).sah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue(), BaseListenable()], [1]);
    LocalDateTimeField$content$1Class = $;
  }
  return LocalDateTimeField$content$1Class;
}
var LocalDateTimeFieldClass;
function LocalDateTimeField() {
  if (LocalDateTimeFieldClass === VOID) {
    class $ extends RViewWithAction() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'input';
        var tmp0 = this.vb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.type' call
        var value = 'datetime-local';
        tmp0.kb7_1.type = value;
        this.vb5_1.jb4_1.v('editable');
        var tmp = this;
        tmp.ic0_1 = LocalDateTimeField$content$1().uby(this);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax()) {
              var tmp0_safe_receiver = this.mbg_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.zbe(this);
              }
            }
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_0.gb4_1['on' + 'keyup'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keyup';
          this_0.gb4_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax()) {
              var tmp0_safe_receiver_0 = this.mbg_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.zbe(this);
              }
            }
            return Unit_instance;
          };
        }
        this.jc0_1 = Align_Start_getInstance();
        this.kc0_1 = get_rem(1);
        this.lc0_1 = null;
      }
    }
    initMetadataForClass($, 'LocalDateTimeField');
    LocalDateTimeFieldClass = $;
  }
  return LocalDateTimeFieldClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        this.mc0_1 = 5;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  return Companion_instance_1;
}
var LocalTimeField$content$1Class;
function LocalTimeField$content$1() {
  if (LocalTimeField$content$1Class === VOID) {
    class $ extends BaseListenable() {
      static pc0(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.oc0_1 = this$0;
        var $this = this.uam($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this$0.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('input', (it) => {
            $this.mal();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.gb4_1['on' + 'input'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'input';
          this_0.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.mal();
            return Unit_instance;
          };
        }
        return $this;
      }
      qc0(value) {
        var tmp0 = this.oc0_1.vb5_1.bb4_1;
        var tmp1_safe_receiver = value == null ? null : value.toString();
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var value_0 = tmp1_safe_receiver == null ? null : take(tmp1_safe_receiver, Companion_instance_1.mc0_1);
        tmp0.kb7_1.value = value_0;
      }
      oam(_set____db54di) {
        return this.qc0((_set____db54di == null ? true : _set____db54di instanceof LocalTime()) ? _set____db54di : THROW_CCE());
      }
      f2() {
        // Inline function 'com.lightningkite.kiteui.views.valueString' call
        var tmp = this.oc0_1.vb5_1.bb4_1.kb7_1.value;
        var tmp0_safe_receiver = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_1;
          // Inline function 'kotlin.text.isEmpty' call
          if (!(charSequenceLength(tmp0_safe_receiver) === 0)) {
            tmp_1 = tmp0_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp1_safe_receiver = tmp_0;
        var tmp_2;
        if (tmp1_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_2 = Companion_getInstance_1().v25(tmp1_safe_receiver);
        }
        return tmp_2;
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (value == null ? true : value instanceof LocalTime()) ? value : THROW_CCE());
      }
    }
    protoOf($).eak = valueSet;
    protoOf($).iah = set;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    protoOf($).sah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue(), BaseListenable()], [1]);
    LocalTimeField$content$1Class = $;
  }
  return LocalTimeField$content$1Class;
}
var LocalTimeFieldClass;
function LocalTimeField() {
  if (LocalTimeFieldClass === VOID) {
    class $ extends RViewWithAction() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'input';
        // Inline function 'com.lightningkite.kiteui.views.type' call
        this.vb5_1.bb4_1.kb7_1.type = 'time';
        this.vb5_1.jb4_1.v('editable');
        var tmp = this;
        tmp.dc2_1 = LocalTimeField$content$1().pc0(this);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.vb5_1;
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax()) {
              var tmp0_safe_receiver = this.mbg_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.zbe(this);
              }
            }
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_0.gb4_1['on' + 'keyup'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keyup';
          this_0.gb4_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax()) {
              var tmp0_safe_receiver_0 = this.mbg_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.zbe(this);
              }
            }
            return Unit_instance;
          };
        }
        this.ec2_1 = Align_Start_getInstance();
        this.fc2_1 = get_rem(1);
        this.gc2_1 = null;
      }
    }
    initMetadataForClass($, 'LocalTimeField');
    LocalTimeFieldClass = $;
  }
  return LocalTimeFieldClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  LocalDateField as LocalDateField1854369auhx0q,
  LocalDateTimeField as LocalDateTimeField29gd1oxpr4f6s,
  LocalTimeField as LocalTimeField1c574dxc0ggzd,
};
//endregion

//# sourceMappingURL=LocalDateTimeField.commonHtml.mjs.map
